import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import * as Yup from "yup";
import api from "../../../config/URL";

function FreeThreshold({ onUpdated }) {
  const [show, setShow] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => {
    setShow(true);
    getData();
  };

  const handleClose = () => setShow(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/freecoin/threshold`);
      const fetchedValue = response?.data?.data?.value || "";
      formik.setValues({ value: fetchedValue });
    } catch (error) {
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object({
    value: Yup.number()
    .typeError("*Value must be a number")
    .required("*Value is required")
    .max(100, "*Maximum value allowed is 100"),
  });

  const formik = useFormik({
    initialValues: {
      value: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoadIndicator(true);
      try {
        const response = await api.post(`admin/freecoin/threshold`, values);
        if (response.status === 200) {
          toast.success("Free Coin Threshold updated successfully!");
          onUpdated();
          handleClose();
        } else {
          toast.error("Failed to update Free Cash Threshold");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Error updating data");
      } finally {
        setLoadIndicator(false);
      }
    },
  });

  return (
    <section>
      <button className="btn btn-sm" onClick={handleShow}>
        <FaEdit />
      </button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Free Coin Threshold</Modal.Title>
        </Modal.Header>
        <form onSubmit={formik.handleSubmit}>
          {loading ? (
            <div className="loader-container">
              <div className="loader">
                <svg viewBox="0 0 80 80">
                  <circle cx="40" cy="40" r="32"></circle>
                </svg>
              </div>
            </div>
          ) : (
            <div className="container py-4">
              <div className="col-12 mb-3">
                <label className="form-label">Value</label>
                <input
                  type="text"
                  name="value"
                  className={`form-control ${
                    formik.touched.value && formik.errors.value
                      ? "is-invalid"
                      : ""
                  }`}
                  value={formik.values.value}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.value && formik.errors.value && (
                  <div className="invalid-feedback">{formik.errors.value}</div>
                )}
              </div>
            </div>
          )}
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-button"
              disabled={loadIndicator}
            >
              {loadIndicator && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                ></span>
              )}
              Update
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </section>
  );
}

export default FreeThreshold;
